// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  background-color: var(--color-card-background);
  color: var(--color-card-text);
  border: none;
}

.non-returnable-card {
  background-color: #fafafa;
}

select {
  border: none;
  border-bottom: 2px solid var(--color-primary);
  height: 40px;
  width: 100%;
  background-color: var(--color-card-background);
}

.is-invalid {
  border-bottom: 2px solid var(--color-error);
}

.Component {
  margin-top: 5%;
  padding-left: 0px;
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-bottom: 10px;
}

.Component1 {
  padding-left: 0px;
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-bottom: 10px;
}

.reason {
  display: inline-block;
  position: absolute;
  font-size: 12px;
  font-weight: 600;
  top: -17px;
  margin-top: 2px;
}

.details {
  margin-top: 3%;
}

input[type=checkbox] {
  margin-left: 4px;
}

input[type=checkbox] {
  display: none;
}

.invalid-feedback {
  margin-bottom: 10px;
}

.non-returnable-item {
  color: #666;
}

.non-returnable-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.non-returnable-checkbox {
  width: 16px;
  height: 16px;
  border-radius: 2px;
  border: 1px solid #b5b5b5;
  background-color: #efefef;
  margin-top: 3px;
  flex-shrink: 0;
}

.non-returnable-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.non-returnable-main {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.non-returnable-media {
  display: flex;
  align-items: center;
}

.non-returnable-image {
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: 4px;
  mix-blend-mode: multiply;
  background-color: transparent;
}

.non-returnable-alt-text {
  font-size: 12px;
  color: #8a8a8a;
  max-width: 70px;
  line-height: 1.2;
}

.non-returnable-label {
  display: inline-flex;
  align-self: flex-start;
  padding: 3px 10px;
  border-radius: 999px;
  border: 1px solid #d3d3d3;
  background-color: #f1f1f1;
  color: #666;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/shared/components/order-details/order-item-details.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,8CAAA;EACA,6BAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AACA;EACE,YAAA;EACA,6CAAA;EACA,YAAA;EACA,WAAA;EACA,8CAAA;AAEF;;AAAA;EACE,2CAAA;AAGF;;AADA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;AAIF;;AAFA;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;AAKF;;AAHA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;AAMF;;AAJA;EACE,cAAA;AAOF;;AAJA;EACE,gBAAA;AAOF;;AAJA;EACE,aAAA;AAOF;;AAJA;EACE,mBAAA;AAOF;;AAJA;EACE,WAAA;AAOF;;AAJA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAOF;;AAJA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;AAOF;;AAJA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAOF;;AAJA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAOF;;AAJA;EACE,aAAA;EACA,mBAAA;AAOF;;AAJA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,6BAAA;AAOF;;AAJA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAOF;;AAJA;EACE,oBAAA;EACA,sBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAOF","sourcesContent":[".card {\n  padding: 16px;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  background-color: var(--color-card-background);\n  color: var(--color-card-text);\n  border: none;\n}\n\n.non-returnable-card {\n  background-color: #fafafa;\n}\nselect {\n  border: none;\n  border-bottom: 2px solid var(--color-primary);\n  height: 40px;\n  width: 100%;\n  background-color: var(--color-card-background);\n}\n.is-invalid {\n  border-bottom: 2px solid var(--color-error);\n}\n.Component {\n  margin-top: 5%;\n  padding-left: 0px;\n  position: relative;\n  width: 100%;\n  min-height: 1px;\n  padding-bottom: 10px;\n}\n.Component1 {\n  padding-left: 0px;\n  position: relative;\n  width: 100%;\n  min-height: 1px;\n  padding-bottom: 10px;\n}\n.reason {\n  display: inline-block;\n  position: absolute;\n  font-size: 12px;\n  font-weight: 600;\n  top: -17px;\n  margin-top: 2px;\n}\n.details {\n  margin-top: 3%;\n}\n\ninput[type=\"checkbox\"] {\n  margin-left: 4px;\n}\n\ninput[type=\"checkbox\"] {\n  display: none;\n}\n\n.invalid-feedback {\n  margin-bottom: 10px;\n}\n\n.non-returnable-item {\n  color: #666;\n}\n\n.non-returnable-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.non-returnable-checkbox {\n  width: 16px;\n  height: 16px;\n  border-radius: 2px;\n  border: 1px solid #b5b5b5;\n  background-color: #efefef;\n  margin-top: 3px;\n  flex-shrink: 0;\n}\n\n.non-returnable-content {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.non-returnable-main {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.non-returnable-media {\n  display: flex;\n  align-items: center;\n}\n\n.non-returnable-image {\n  width: 56px;\n  height: 56px;\n  object-fit: cover;\n  border-radius: 4px;\n  mix-blend-mode: multiply;\n  background-color: transparent;\n}\n\n.non-returnable-alt-text {\n  font-size: 12px;\n  color: #8a8a8a;\n  max-width: 70px;\n  line-height: 1.2;\n}\n\n.non-returnable-label {\n  display: inline-flex;\n  align-self: flex-start;\n  padding: 3px 10px;\n  border-radius: 999px;\n  border: 1px solid #d3d3d3;\n  background-color: #f1f1f1;\n  color: #666;\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
